interface IconOptions {
	link?: string,
	onClick?: (this: HTMLButtonElement, ev: PointerEvent) => any,
	ariaLabel?: string,
	className?: string,
	target?: '_self' | '_blank';
}
const IconOptionsDefault: IconOptions = {
	target: '_blank',
}

export type icon = 'fandom' | 'miraheze' | 'share' | 'link';

export class Icon {
	private options: IconOptions;

	constructor(private icon: icon, opts?: IconOptions) {
		this.options = { ...IconOptionsDefault, ...opts };
	}

	render(): HTMLElement {
		const icon = document.createElement('i');
		icon.className = `icon icon-${this.icon}`;
		let result: HTMLElement | undefined;
		if (this.options.onClick) {
			const button = document.createElement('button');
			button.className = 'btn btn-icon';
			button.addEventListener('click', this.options.onClick);
			result = button;
		} else if (this.options.link) {
			const anchor = document.createElement('a');
			anchor.href = this.options.link;
			anchor.target = this.options.target!;
			result = anchor;
		}
		if (result) {
			if (this.options.ariaLabel) {
				result.ariaLabel = this.options.ariaLabel;
				result.title = this.options.ariaLabel;
			}
			result.innerHTML = icon.outerHTML;
		} else {
			result = icon;
		}
		result.className += ` ${this.options.className ?? ''}`;
		result.className = result.className.trim();
		return result;
	}

	jquery(): JQuery {
		return $(this.render());
	}
}

export namespace Icon {
	export const Render = (icon: icon, opts?: IconOptions) => new Icon(icon, opts).render();
	export const JQuery = (icon: icon, opts?: IconOptions) => new Icon(icon, opts).jquery();
}